import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLogout } from '../hooks/useLogout';
import { apiClient } from '../services/authService';
import './UserMenu.css';

function UserMenu() {
  const [user, setUser] = useState(null);
  const [showMenu, setShowMenu] = useState(false);
  const menuRef = useRef(null);
  const navigate = useNavigate();
  const handleLogout = useLogout();

  useEffect(() => {
    // Obtener información del usuario
    const fetchUser = async () => {
      try {
        const response = await apiClient.get('/auth/me');
        setUser(response.data);
      } catch (error) {
        console.error('Error fetching user info:', error);
      }
    };

    fetchUser();
  }, []);

  // Cerrar menú al hacer clic fuera
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };

    if (showMenu) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showMenu]);

  const getInitials = (username) => {
    if (!username) return 'U';
    const parts = username.trim().split(' ');
    if (parts.length >= 2) {
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    return username.substring(0, 2).toUpperCase();
  };

  const handleSettings = () => {
    setShowMenu(false);
    navigate('/settings');
  };

  const handleSignOut = () => {
    setShowMenu(false);
    handleLogout();
  };

  if (!user) {
    return null;
  }

  return (
    <div className="user-menu-container" ref={menuRef}>
      <button
        className="user-menu-button"
        onClick={() => setShowMenu(!showMenu)}
        aria-label="User menu"
      >
        <span className="user-initials">{getInitials(user.username)}</span>
      </button>
      
      {showMenu && (
        <div className="user-menu-dropdown">
          <div className="user-menu-header">
            <span className="user-menu-username">{user.username}</span>
            <span className="user-menu-email">{user.email}</span>
          </div>
          <div className="user-menu-divider"></div>
          <button className="user-menu-item" onClick={handleSettings}>
            <span className="user-menu-icon">⚙️</span>
            Settings
          </button>
          <button className="user-menu-item" onClick={handleSignOut}>
            <span className="user-menu-icon">🚪</span>
            Sign Out
          </button>
        </div>
      )}
    </div>
  );
}

export default UserMenu;



